export enum ScreenChapterStartHorizontalPositionEnum {
  LEFT = "LEFT",
  CENTER = "CENTER",
  RIGHT = "RIGHT",
}

export enum ScreenChapterStartVerticalPositionEnum {
  TOP = "TOP",
  CENTER = "CENTER",
  BOTTOM = "BOTTOM",
}

export enum ScreenChapterStartAnimationEnum {
  WITHOUT_FULL_SCREEN = "WITHOUT_FULL_SCREEN",
  WITHOUT_NO_CROP = "WITHOUT_NO_CROP",
  WITHOUT_AND_BLUR_BACKGROUND = "WITHOUT_AND_BLUR_BACKGROUND",
  FROM_TOP = "FROM_TOP",
  FROM_BOTTOM = "FROM_BOTTOM",
  FROM_LEFT_TO_RIGHT = "FROM_LEFT_TO_RIGHT",
  FROM_RIGHT_TO_LEFT = "FROM_RIGHT_TO_LEFT",
}

export enum ScreenChapterIntroTextThemeEnum {
  LIGHT = "light",
  DARK = "dark",
}

export enum ScreenChapterIntroTextHaloEffectOnEnum {
  ON = "on",
  OFF = "off",
}
